import React from 'react';
import { Container, GridItem } from '@fiverr-private/layout_components';
import { Heading, Link, Typography } from '@fiverr-private/typography';
import { theme } from '@fiverr-private/theme';
import { PressRelease } from '../../../types/types';
import { DateLine } from '../DateLine';

export const PressReleaseCard = ({ release }: { release: PressRelease }) => {
  const releaseYear = new Date(release.data.date).getFullYear().toString();

  return (
    <GridItem>
      <blockquote data-year={releaseYear} cite={release.data.handle}>
        <Container
          width="100%"
          height="243px"
          background={`no-repeat center / cover url("${release.data.image}") ${theme.colors.green_700}`}
        >
          <Link href={release.data.source} target="_blank" width="100%" height="100%" style={{ display: 'block' }} />
        </Container>
        <DateLine date={release.data.date} fontWeight="bold" />
        <Heading as="h3" size="h_sm" minHeight="56px" marginBottom="2">
          <Link
            href={`/news${release.data.handle}`}
            decoration="none"
            color={{ default: 'grey_1200', hover: 'green_700' }}
          >
            {release.data.title}
          </Link>
        </Heading>
        <Typography size="b_lg" fontWeight="normal" color="bodySecondary" lineHeight="b_xxl" marginBottom="2">
          {release.data.teaser}
        </Typography>
      </blockquote>
    </GridItem>
  );
};
